// This component is not used anywhere as far as I can see, it's commented out from the layout.

import Icon from 'components/shared/icon';
import Image from 'components/shared/image';
import { useUI } from 'hooks';
import { useGlobalModules } from 'contexts';
import styles from './confirmWishlistPopup.module.scss';

const ConfirmWishlistPopup = () => {
  const globalModules = useGlobalModules();

  const { message, closeButtonText } = globalModules?.translations?.confirmWishlistPopup || {};
  const { confirmWishlistData, displayConfirmWishlistPopup, closeConfirmWishlistPopup } = useUI();

  if (!displayConfirmWishlistPopup) return null;
  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <button
          type="button"
          className={styles.closeBtn}
          onClick={() => {
            closeConfirmWishlistPopup();
          }}
        >
          <Icon type="close" />
        </button>
        <div className={styles.message}>{message}</div>
        <div className={styles.productInfo}>
          <div className={styles.itemImage}>
            <Image src={confirmWishlistData?.merchandise?.image} layout="fill" />
          </div>
          <span className={styles.productTitle}>
            {confirmWishlistData?.merchandise?.product?.title}
          </span>
        </div>
        <div className={styles.buttons}>
          <button
            type="button"
            className={styles.button}
            onClick={() => closeConfirmWishlistPopup()}
          >
            {closeButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmWishlistPopup;
